var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9467_233157)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5464 12.4058C2.31263 12.3908 2.11096 12.1891 2.09595 11.9553L1.86532 8.36375C1.85031 8.12999 2.02764 7.95265 2.26141 7.96766C2.49517 7.98267 2.69685 8.18435 2.71186 8.41811L2.87687 10.9878L5.84172 8.02297C5.9964 7.86828 6.2644 7.88549 6.44031 8.0614C6.61622 8.23731 6.63343 8.50531 6.47875 8.66L3.5139 11.6248L6.0836 11.7899C6.31737 11.8049 6.51904 12.0065 6.53405 12.2403C6.54906 12.4741 6.37173 12.6514 6.13796 12.6364L2.5464 12.4058Z",
    fill: "#1C39BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9208 3.03916C11.9066 2.80463 11.7049 2.60295 11.4704 2.58871L7.86709 2.3698C7.63256 2.35555 7.45399 2.53412 7.46823 2.76865C7.48248 3.00318 7.68416 3.20485 7.91868 3.2191L10.4968 3.37572L7.51125 6.36125C7.35549 6.51701 7.37182 6.78588 7.54773 6.96179C7.72364 7.13771 7.99252 7.15404 8.14828 6.99828L11.1338 4.01276L11.2904 6.59084C11.3047 6.82537 11.5063 7.02704 11.7409 7.04129C11.9754 7.05554 12.154 6.87697 12.1397 6.64244L11.9208 3.03916Z",
    fill: "#1C39BB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9467_233157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/viewIcon.e6983b3c48f0f7334dfd83d03b6615fa.svg";
export { ForwardRef as ReactComponent };